export function setAuth(code, at, rt){
    return {
        type: 'SET_AUTH',
        payload: {
            code,
            accessToken: at,
            refreshToken: rt
        }
    }
}

export function setPlaylists(playlists){
    return {
        type: 'FETCH_LIST',
        payload: playlists
    }
}